// extracted by mini-css-extract-plugin
export default {"link":"DK-z","disabled":"EK-z"};